import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Entry2xmjmyutzoq3p as Entry } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { MAP_getInstance141vh6u7faopd as MAP_getInstance } from '../descriptors/SerialKinds.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor,
  buildClassSerialDescriptors2a6xdp6mrtw as buildClassSerialDescriptor,
} from '../descriptors/SerialDescriptors.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Paire9pteg33gng7 as Pair,
  to2cs3ny02qtbcb as to,
  Triple1vhi3d0dgpnjb as Triple,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_NULL() {
  _init_properties_Tuples_kt__dz0qyd();
  return NULL;
}
var NULL;
var MapEntryClass;
function MapEntry() {
  if (MapEntryClass === VOID) {
    class $ {
      constructor(key, value) {
        this.p26_1 = key;
        this.q26_1 = value;
      }
      m3() {
        return this.p26_1;
      }
      n3() {
        return this.q26_1;
      }
      toString() {
        return 'MapEntry(key=' + toString(this.p26_1) + ', value=' + toString(this.q26_1) + ')';
      }
      hashCode() {
        var result = this.p26_1 == null ? 0 : hashCode(this.p26_1);
        result = imul(result, 31) + (this.q26_1 == null ? 0 : hashCode(this.q26_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MapEntry()))
          return false;
        if (!equals(this.p26_1, other.p26_1))
          return false;
        if (!equals(this.q26_1, other.q26_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'MapEntry', VOID, VOID, [Entry()]);
    MapEntryClass = $;
  }
  return MapEntryClass;
}
var MapEntrySerializerClass;
function MapEntrySerializer() {
  if (MapEntrySerializerClass === VOID) {
    class $ extends KeyValueSerializer() {
      constructor(keySerializer, valueSerializer) {
        super(keySerializer, valueSerializer);
        var tmp = this;
        var tmp_0 = MAP_getInstance();
        tmp.t26_1 = buildSerialDescriptor('kotlin.collections.Map.Entry', tmp_0, [], ($this$buildSerialDescriptor) => {
          $this$buildSerialDescriptor.l1n('key', keySerializer.s1m());
          $this$buildSerialDescriptor.l1n('value', valueSerializer.s1m());
          return Unit_instance;
        });
      }
      s1m() {
        return this.t26_1;
      }
      u26(_this__u8e3s4) {
        return _this__u8e3s4.m3();
      }
      v26(_this__u8e3s4) {
        return this.u26((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      w26(_this__u8e3s4) {
        return _this__u8e3s4.n3();
      }
      x26(_this__u8e3s4) {
        return this.w26((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      y26(key, value) {
        return new (MapEntry())(key, value);
      }
    }
    initMetadataForClass($, 'MapEntrySerializer');
    MapEntrySerializerClass = $;
  }
  return MapEntrySerializerClass;
}
var PairSerializerClass;
function PairSerializer() {
  if (PairSerializerClass === VOID) {
    class $ extends KeyValueSerializer() {
      constructor(keySerializer, valueSerializer) {
        super(keySerializer, valueSerializer);
        var tmp = this;
        tmp.e27_1 = buildClassSerialDescriptor('kotlin.Pair', [], ($this$buildClassSerialDescriptor) => {
          $this$buildClassSerialDescriptor.l1n('first', keySerializer.s1m());
          $this$buildClassSerialDescriptor.l1n('second', valueSerializer.s1m());
          return Unit_instance;
        });
      }
      s1m() {
        return this.e27_1;
      }
      f27(_this__u8e3s4) {
        return _this__u8e3s4.ue_1;
      }
      v26(_this__u8e3s4) {
        return this.f27(_this__u8e3s4 instanceof Pair() ? _this__u8e3s4 : THROW_CCE());
      }
      g27(_this__u8e3s4) {
        return _this__u8e3s4.ve_1;
      }
      x26(_this__u8e3s4) {
        return this.g27(_this__u8e3s4 instanceof Pair() ? _this__u8e3s4 : THROW_CCE());
      }
      y26(key, value) {
        return to(key, value);
      }
    }
    initMetadataForClass($, 'PairSerializer');
    PairSerializerClass = $;
  }
  return PairSerializerClass;
}
function decodeSequentially($this, composite) {
  var a = composite.w1r($this.k27_1, 0, $this.h27_1);
  var b = composite.w1r($this.k27_1, 1, $this.i27_1);
  var c = composite.w1r($this.k27_1, 2, $this.j27_1);
  composite.k1r($this.k27_1);
  return new (Triple())(a, b, c);
}
function decodeStructure($this, composite) {
  var a = get_NULL();
  var b = get_NULL();
  var c = get_NULL();
  mainLoop: while (true) {
    var index = composite.a1s($this.k27_1);
    switch (index) {
      case -1:
        break mainLoop;
      case 0:
        a = composite.w1r($this.k27_1, 0, $this.h27_1);
        break;
      case 1:
        b = composite.w1r($this.k27_1, 1, $this.i27_1);
        break;
      case 2:
        c = composite.w1r($this.k27_1, 2, $this.j27_1);
        break;
      default:
        throw SerializationException().n1o('Unexpected index ' + index);
    }
  }
  composite.k1r($this.k27_1);
  if (a === get_NULL())
    throw SerializationException().n1o("Element 'first' is missing");
  if (b === get_NULL())
    throw SerializationException().n1o("Element 'second' is missing");
  if (c === get_NULL())
    throw SerializationException().n1o("Element 'third' is missing");
  return new (Triple())(a, b, c);
}
var TripleSerializerClass;
function TripleSerializer() {
  if (TripleSerializerClass === VOID) {
    class $ {
      constructor(aSerializer, bSerializer, cSerializer) {
        this.h27_1 = aSerializer;
        this.i27_1 = bSerializer;
        this.j27_1 = cSerializer;
        var tmp = this;
        tmp.k27_1 = buildClassSerialDescriptor('kotlin.Triple', [], ($this$buildClassSerialDescriptor) => {
          $this$buildClassSerialDescriptor.l1n('first', this.h27_1.s1m());
          $this$buildClassSerialDescriptor.l1n('second', this.i27_1.s1m());
          $this$buildClassSerialDescriptor.l1n('third', this.j27_1.s1m());
          return Unit_instance;
        });
      }
      s1m() {
        return this.k27_1;
      }
      l27(encoder, value) {
        var structuredEncoder = encoder.j1r(this.k27_1);
        structuredEncoder.b1t(this.k27_1, 0, this.h27_1, value.nt_1);
        structuredEncoder.b1t(this.k27_1, 1, this.i27_1, value.ot_1);
        structuredEncoder.b1t(this.k27_1, 2, this.j27_1, value.pt_1);
        structuredEncoder.k1r(this.k27_1);
      }
      t1m(encoder, value) {
        return this.l27(encoder, value instanceof Triple() ? value : THROW_CCE());
      }
      u1m(decoder) {
        var composite = decoder.j1r(this.k27_1);
        if (composite.z1r()) {
          return decodeSequentially(this, composite);
        }
        return decodeStructure(this, composite);
      }
    }
    initMetadataForClass($, 'TripleSerializer', VOID, VOID, [KSerializer()]);
    TripleSerializerClass = $;
  }
  return TripleSerializerClass;
}
var KeyValueSerializerClass;
function KeyValueSerializer() {
  if (KeyValueSerializerClass === VOID) {
    class $ {
      constructor(keySerializer, valueSerializer) {
        this.z26_1 = keySerializer;
        this.a27_1 = valueSerializer;
      }
      b27(encoder, value) {
        var structuredEncoder = encoder.j1r(this.s1m());
        structuredEncoder.b1t(this.s1m(), 0, this.z26_1, this.v26(value));
        structuredEncoder.b1t(this.s1m(), 1, this.a27_1, this.x26(value));
        structuredEncoder.k1r(this.s1m());
      }
      t1m(encoder, value) {
        return this.b27(encoder, value);
      }
      u1m(decoder) {
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.s1m();
        var composite = decoder.j1r(descriptor);
        var tmp$ret$1;
        $l$block: {
          if (composite.z1r()) {
            var key = composite.w1r(this.s1m(), 0, this.z26_1);
            var value = composite.w1r(this.s1m(), 1, this.a27_1);
            tmp$ret$1 = this.y26(key, value);
            break $l$block;
          }
          var key_0 = get_NULL();
          var value_0 = get_NULL();
          mainLoop: while (true) {
            var idx = composite.a1s(this.s1m());
            switch (idx) {
              case -1:
                break mainLoop;
              case 0:
                key_0 = composite.w1r(this.s1m(), 0, this.z26_1);
                break;
              case 1:
                value_0 = composite.w1r(this.s1m(), 1, this.a27_1);
                break;
              default:
                throw SerializationException().n1o('Invalid index: ' + idx);
            }
          }
          if (key_0 === get_NULL())
            throw SerializationException().n1o("Element 'key' is missing");
          if (value_0 === get_NULL())
            throw SerializationException().n1o("Element 'value' is missing");
          tmp$ret$1 = this.y26(key_0, value_0);
        }
        var result = tmp$ret$1;
        composite.k1r(descriptor);
        return result;
      }
    }
    initMetadataForClass($, 'KeyValueSerializer', VOID, VOID, [KSerializer()]);
    KeyValueSerializerClass = $;
  }
  return KeyValueSerializerClass;
}
var properties_initialized_Tuples_kt_3vs7ar;
function _init_properties_Tuples_kt__dz0qyd() {
  if (!properties_initialized_Tuples_kt_3vs7ar) {
    properties_initialized_Tuples_kt_3vs7ar = true;
    NULL = new Object();
  }
}
//region block: exports
export {
  MapEntrySerializer as MapEntrySerializer2ukwamih4zw76,
  PairSerializer as PairSerializerpzh6nuee9oov,
  TripleSerializer as TripleSerializer25andm5j3t9nu,
};
//endregion

//# sourceMappingURL=Tuples.mjs.map
